import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { Endpoints } from 'app/core/constants/Endpoints';
import { environment } from '../../environments/environment';
import { from, switchMap, throwError, catchError } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public baseURL: string;
 public anonymous: any;

  constructor(private http: HttpClient) {
   this.loadAnonymous();
    this.baseURL = environment.apiBaseURL;
    
  }
    private async getDeviceId(): Promise<string> {
    let deviceId = (await Preferences.get({ key: 'device_id' })).value;
    if (!deviceId) {
      deviceId = uuidv4();
      await Preferences.set({ key: 'device_id', value: deviceId });
    }
    return deviceId;
  } 

  private async getDeviceType(): Promise<string> {
    let deviceType = (await Preferences.get({ key: 'device_type' })).value;
    if (!deviceType) {
      const info = await Device.getInfo();
      deviceType = info.platform.toUpperCase(); // "ANDROID", "IOS", "WEB"
      await Preferences.set({ key: 'device_type', value: deviceType });
    }
    return deviceType;
  }

  private createAuthHeaders(deviceId: string, deviceType: string): HttpHeaders {
    return new HttpHeaders()
      .set('Authorization', `Bearer ${this.anonymous}`)
      .set('X-App-Type', 'LUNA_ADMIN')
      .set('X-Device-Id', deviceId)
      .set('X-Device-Type', deviceType)
      .set('X-Auth-Type', 'ANON');
  }

   userLogin(dataObject: any) {
    return from(Promise.all([
      this.loadAnonymous(),
      this.getDeviceId(),
      this.getDeviceType()
    ])).pipe(
      switchMap(([anonymousToken, deviceId, deviceType]) => {
        // If anonymous token is missing or expired, refresh it first
        if (!anonymousToken || anonymousToken === 'null' || anonymousToken === 'undefined') {
          console.warn('Anonymous token is missing or invalid, refreshing from splash screen');
          return this.splashScreen().pipe(
            switchMap((splashResponse: any) => {
              if (splashResponse?.status && splashResponse?.anonymousToken) {
                Preferences.set({ key: 'anonymouse', value: splashResponse.anonymousToken });
                this.anonymous = splashResponse.anonymousToken;
                const headers = this.createAuthHeaders(deviceId, deviceType);
                return this.http.post(this.baseURL + Endpoints.login.login, dataObject, { headers });
              } else {
                return throwError(() => new Error('Failed to get anonymous token from splash screen'));
              }
            })
          );
        }
        const headers = this.createAuthHeaders(deviceId, deviceType);
        return this.http.post(this.baseURL + Endpoints.login.login, dataObject, { headers }).pipe(
          catchError((error: HttpErrorResponse) => {
            // If login fails with 401 and JWT expired, refresh anonymous token and retry
            if (error.status === 401 && error.error?.error?.includes('JWT token is expired')) {
              console.warn('Anonymous token expired, refreshing and retrying login');
              return this.splashScreen().pipe(
                switchMap((splashResponse: any) => {
                  if (splashResponse?.status && splashResponse?.anonymousToken) {
                    Preferences.set({ key: 'anonymouse', value: splashResponse.anonymousToken });
                    this.anonymous = splashResponse.anonymousToken;
                    const newHeaders = this.createAuthHeaders(deviceId, deviceType);
                    return this.http.post(this.baseURL + Endpoints.login.login, dataObject, { headers: newHeaders });
                  } else {
                    return throwError(() => error);
                  }
                })
              );
            }
            return throwError(() => error);
          })
        );
      })
    );
  }

  private async loadAnonymous() {
    const { value } = await Preferences.get({ key: 'anonymouse' });
    console.log(value, "anonymous")
    this.anonymous = value;
    return value;
  }

  splashScreen() {
      return from(Promise.all([this.getDeviceId(), this.getDeviceType()])).pipe(
      switchMap(([deviceId, deviceType]) => {
        const body = {
          appType: 'LUNA_ADMIN',
          deviceId,
          deviceType
        };
      
    return this.http.post(this.baseURL + Endpoints.SplashScreen.splashScreen, body);
    })
    );
  }

    sendOtp(dataObject: any) {
        return from(Promise.all([
      this.loadAnonymous(),
      this.getDeviceId(),
      this.getDeviceType()
    ])).pipe(
      switchMap(([_, deviceId, deviceType]) => {
        const headers = this.createAuthHeaders(deviceId, deviceType);
    return this.http.post(this.baseURL + Endpoints.register.sendOtp, dataObject, { headers });
   })
    );
  }

  validateotp(dataObject: any) {
     return from(Promise.all([
      this.loadAnonymous(),
      this.getDeviceId(),
      this.getDeviceType()
    ])).pipe(
      switchMap(([_, deviceId, deviceType]) => {
        const headers = this.createAuthHeaders(deviceId, deviceType);
    return this.http.post(this.baseURL + Endpoints.register.validateotp, dataObject, { headers });
    })
    );
  }

  setPin(dataObject: any) {
      return from(Promise.all([
      this.loadAnonymous(),
      this.getDeviceId(),
      this.getDeviceType()
    ])).pipe(
      switchMap(([_, deviceId, deviceType]) => {
        const headers = this.createAuthHeaders(deviceId, deviceType);
    return this.http.post(this.baseURL + Endpoints.register.setPin, dataObject, { headers });
     })
    );
  }
}
